export default {
  namespaced: true,

  actions: {
    type({commit}, type) {
      // shop
      window.Shopify = {
        shop: 'dev.local.store',
        Checkout: {
          OrderStatus: {
            addContentBox: (html) => {
              // eslint-disable-next-line
              console.log('DEV addContentBox was triggered');
            },
          },
        },
      };

      // page
      window.ShopifyAnalytics = {
        meta: {
          page: {
            customerId: null,
            pageType: type,
          },
        },
        lib: {
          user: () => {
            return {
              traits: () => {
                return {
                  uniqToken: '1010101010101010101',
                };
              },
            };
          },
        },
      };
    },
  },
};
